import React from 'react';
import styled from 'styled-components';

import { LFC } from '../Legacy';
import { Colors } from './Colors';
import { Prompt } from './Prompt';

const activeColor = Colors.primaryLight;

const Frame = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const Row = styled.div`
    display: flex;
    width: 6rem;
    height: 2rem;
`;

const Cell = styled.div`
    width: 2rem;
    height: 2rem;
`;

const Button = styled.div<{ active?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
    color: ${p => p.active ? activeColor : '#C4C4C4'};
    border-radius: 4px;
    &:hover {
        background: whitesmoke;
        cursor: pointer;
    }
`;

const Edge: LFC<{ direction: number }> = ({ direction }) => <>
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" style={{ transform: `rotate(${90 * direction}deg)` }}>
        <g>
            <rect y="20" width="20" height="4" transform="rotate(-90 0 20)" fill="currentColor" />
            <rect y="12" width="4" height="18" transform="rotate(-90 0 12)" fill="currentColor" />
        </g>
    </svg>
</>;

const Cross: LFC<{ x?: boolean, y?: boolean }> = ({ x, y }) => <>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g>
            {x && <rect y="14" width="32" height="4" fill={activeColor} />}
            {y && <rect y="14" width="32" height="4" transform="rotate(-90, 16, 16)" fill={activeColor} />}
        </g>
    </svg>
</>;

export interface AnchorValues {
    left?: boolean;
    top?: boolean;
    right?: boolean;
    bottom?: boolean;
}

export type AnchorSelectorCallback = (values: AnchorValues, complete: boolean) => void;

export class AnchorSelector extends React.Component<{ initialValues?: AnchorValues, onSelect: AnchorSelectorCallback }> {

    public state = {} as AnchorValues;

    public render() {
        const { left, top, right, bottom } = this.state;
        return <Frame>
            <Prompt ignoreMouse onAction={this.onPromptAction}>
                <Row>
                    <Cell></Cell>
                    <Cell>
                        <Button active={top} onClick={() => this.onToggle('top')}>
                            <Edge direction={1} />
                        </Button>
                    </Cell>
                    <Cell></Cell>
                </Row>
                <Row>
                    <Cell>
                        <Button active={left} onClick={() => this.onToggle('left')}>
                            <Edge direction={0} />
                        </Button>
                    </Cell>
                    <Cell>
                        <Cross x={left && right} y={top && bottom} />
                    </Cell>
                    <Cell>
                        <Button active={right} onClick={() => this.onToggle('right')}>
                            <Edge direction={2} />
                        </Button>
                    </Cell>
                </Row>
                <Row>
                    <Cell></Cell>
                    <Cell>
                        <Button active={bottom} onClick={() => this.onToggle('bottom')}>
                            <Edge direction={3} />
                        </Button>
                    </Cell>
                    <Cell></Cell>
                </Row>
            </Prompt>
        </Frame>;
    }

    public componentDidMount() {
        this.setState(this.props.initialValues ?? {});
    }

    private onPromptAction = (confirm: boolean) => {
        this.props.onSelect(this.state, confirm);
    };

    private onToggle = (edge: keyof AnchorValues) => {
        this.setState({ [edge]: !this.state[edge] }, () => {
            this.onPromptAction(false);
        });
    };
}
